import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useTrackContext } from "../../../../../hooks/useTrackContext";

interface IProps {
  handleClosePopup: () => void;
  isPopupShowing: boolean;
}

const ExpertInfomationPopup: React.FC<IProps> = ({ handleClosePopup, isPopupShowing }) => {
  const { metaObjectMainTrackSectionConfig } = useTrackContext();

  const { sixteenPlusSection } = metaObjectMainTrackSectionConfig;

  const content = sixteenPlusSection.expertPopupText;
  // use metaobject
  return (
    <>
      {isPopupShowing && (
        <div className="tw-fixed tw-z-[1000] tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-900 tw-bg-opacity-50">
          <div className="tw-mx-[20px] lg:tw-mx-0">
            <div className="tw-bg-[#393B41] lg:tw-max-w-[998px] tw-w-full tw-mx-auto tw-rounded-[15px] tw-shadow-lg tw-overflow-hidden tw-transform tw-transition-all tw-duration-300 tw-scale-100">
              <div className="tw-py-[10px] tw-px-[10px]">
                <div className="tw-flex tw-justify-end">
                  <button className="tw-text-gray-600 tw-text-lg tw-p-2 tw-hover:text-gray-800 tw-focus:tw-outline-none" onClick={handleClosePopup}>
                    <AiOutlineClose className="tw-w-[30px] tw-h-[30px] tw-text-white tw-font-[400]" />
                  </button>
                </div>
                <div className="tw-flex tw-justify-center tw-items-center">
                  <div className="tw-text-white tw-text-left tw-p-0 lg:tw-pb-[30px] lg:tw-px-[80px] tw-relative">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: content as string,
                      }}
                    />
                    <button
                      onClick={handleClosePopup}
                      className="tw-mt-[30px] tw-mb-[30px] lg:tw-mb-0 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-w-fit tw-h-[57px] tw-overflow-hidden tw-py-[16px] tw-px-[40px] tw-font-bold tw-text-[18px] tw-rounded-[100px] tw-text-white tw-bg-[linear-gradient(71deg,#a852ff_28.13%,#7886ff)]"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpertInfomationPopup;
